import "./left-navbar.css";

import { Link } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";
import { getBaseUrl } from "~/shared/utils/get-base-url.ts";

import { EnvironmentIndicator } from "../environment-indicator/environment-indicator.tsx";
import type { LeftNavBarItemProps } from "../left-navbar-item/left-navbar-item.tsx";
import { LeftNavBarItem } from "../left-navbar-item/left-navbar-item.tsx";

type LeftNavbarProps = {
	upperItemDetails: LeftNavBarItemProps[];
	lowerItemDetails: LeftNavBarItemProps[];
	forceShow?: boolean;
	onItemActivated?: () => void;
};

{
	/* Left Nav Bar */
}
export function LeftNavbar({
	upperItemDetails,
	lowerItemDetails,
	forceShow = false,
	onItemActivated,
}: Readonly<LeftNavbarProps>) {
	const baseUrl = getBaseUrl();

	return (
		<div
			className={forceShow ? "left-navbar-mobile-open" : undefined}
			data-testid={"left-navbar-root"}
			id={"left-navbar"}
		>
			<EnvironmentIndicator />
			<div id={"left-navbar-upper-details"}>
				<div className={"trax-logo-wrapper"}>
					<Link id={"trax-logo"} to={routes.root}>
						<img
							alt={"TQL Logo"}
							src={`${baseUrl}/images/tql-stacked-white.png`}
						/>
					</Link>
				</div>
				{upperItemDetails.map((item) => (
					<LeftNavBarItem
						key={item.label}
						item={item}
						onActivated={onItemActivated}
					/>
				))}
			</div>
			<div id={"left-navbar-lower-details"}>
				{lowerItemDetails.map((item) => (
					<LeftNavBarItem
						key={item.label}
						item={item}
						onActivated={onItemActivated}
					/>
				))}
			</div>
		</div>
	);
}
